import { MapPin } from "lucide-react"
import { SearchBox } from '@mapbox/search-js-react'
import { SearchBoxFeatureSuggestion, SearchBoxRetrieveResponse } from "@mapbox/search-js-core"

interface LocationSearchSectionProps {
  accessToken: string
  inputValue: string
  onInputChange: (value: string) => void
  onLocationSelect: (result: SearchBoxRetrieveResponse) => void
  selectedLocationFeature: SearchBoxFeatureSuggestion | null
}

export function LocationSearchSection({
  accessToken,
  inputValue,
  onInputChange,
  onLocationSelect,
  selectedLocationFeature
}: LocationSearchSectionProps) {
  return (
    <div className="bg-white px-4">
      <div className="space-y-3">
        <div>
          <h2 className="font-semibold mb-1">Search Location</h2>
          <p className="text-sm text-gray-600">Find a place to add to your itinerary</p>
        </div>
        <div className="relative">
          {/* @ts-ignore */}
          <SearchBox
            accessToken={accessToken}
            value={inputValue}
            onChange={onInputChange}
            onRetrieve={onLocationSelect}
            options={{
              language: 'en',
            }}
          />
          {selectedLocationFeature && (
            <div className="mt-2 rounded-lg border border-primary/20 bg-primary/5 p-3">
              <div className="flex items-center gap-3">
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/20 flex-shrink-0">
                  <MapPin className="h-3 w-3 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">
                    {selectedLocationFeature.properties.name}
                  </p>
                  <p className="text-xs text-gray-600 truncate">
                    {selectedLocationFeature.properties.full_address}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 